export default __webpack_public_path__ + "static/finportcase2-39da9c83f5bb7a603cc81c037a57e78d.png";